import SMToolbar from './SMToolbar';
export default SMToolbar;